//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    reminder: [],
    searchRequest: null,
  },
  mutations: {
    updateReminder(state, reminder) {
      state.reminder = reminder;
    },
    updateSearchReminderRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadReminder({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));


    if (requestToSend.assignDate.startDate)
    {
        const date = moment(requestToSend.assignDate.startDate)
                    .endOf('d')
                    .toDate();
        console.log(date)
        console.log(date.getMonth())
        console.log(date.getDate())
        var month = (date.getMonth() + 1).toString()
        if (month.length === 1)
        {
            month = '0' + month
        }

        var day = date.getDate().toString()
        if (day.length === 1)
        {
            day = '0' + day
        }

        requestToSend.assignDate.startDate = date.getFullYear() + '-' + month + '-' + day
    }

    if (requestToSend.assignDate.endDate)
    {
        
        
        const date = moment(requestToSend.assignDate.endDate)
                    .endOf('d')
                    .toDate();

                    var month = (date.getMonth() + 1).toString()
                    if (month.length == 1)
                    {
                        month = '0' + month
                    }
            
                    var day = date.getDate().toString()
                    if (day.length == 1)
                    {
                        day = '0' + day
                    }
        requestToSend.assignDate.endDate = date.getFullYear() + '-' + month + '-' + day
    }
    else
    {

        if (requestToSend.assignDate.startDate != null)
        {
            const date = moment(requestToSend.assignDate.startDate)
                    .endOf('d')
                    .toDate();
        console.log(date)
        console.log(date.getMonth())
        console.log(date.getDate())
        var month = (date.getMonth() + 1).toString()
        if (month.length === 1)
        {
            month = '0' + month
        }

        var day = date.getDate().toString()
        if (day.length === 1)
        {
            day = '0' + day
        }

        requestToSend.assignDate.endDate = date.getFullYear() + '-' + month + '-' + day
        }


        
    }

    //   if (requestToSend.punchDate.endDate) {
         
    //     requestToSend.punchDate.endDate = moment(requestToSend.punchDate.endDate)
    //       .endOf('d')
    //       .toDate();
    //   }
      
    //   if (requestToSend.punchDate.startDate && !requestToSend.punchDate.endDate) {
    //     requestToSend.punchDate.endDate = moment(requestToSend.punchDate.startDate)
    //       .endOf('d')
    //       .toDate();
    //   }
      if (requestToSend.users.length === 0 && requestToSend.usersInTeam && requestToSend.usersInTeam.length > 0) {
        requestToSend.users = requestToSend.usersInTeam;
      }

      //const result = await api.post('/api/w/ccic/reminder', requestToSend);
      const result = await newAPIPost('/api/w/ccic/reminder', requestToSend);
      commit('updateSearchReminderRequest', fallbackRequest);
      return commit('updateReminder', result);
    },
  },
  getters: {
    getReminder: state => state.reminder,
  },
};
